import { dayjs } from '@weft/utils';
import type { Dayjs } from '@weft/utils';

export function formatDate(date: Date | Dayjs, dateFormat = 'MMM. D, YY') {
  return dayjs(date).utc().format(dateFormat);
}

export function formatDateToDMY(date: Date | Dayjs) {
  return dayjs(date).utc().format('DD.MM.YYYY');
}

export function utcTimeFromDayjs(dayjsDate: Dayjs) {
  const utcDateInMilliseconds = Date.UTC(
    dayjsDate.year(),
    dayjsDate.month(),
    dayjsDate.date(),
    dayjsDate.hour(),
    dayjsDate.minute(),
    dayjsDate.second(),
  );

  return new Date(utcDateInMilliseconds);
}
export function compareDatesDescending(firstDate: Date, secondDate: Date) {
  return new Date(secondDate).getTime() - new Date(firstDate).getTime();
}

export function getCurrentDate() {
  return new Date();
}

export function formatDurationBetweenDates(startDate: Dayjs | Date, endDate: Dayjs | Date): string {
  const dateDiff = dayjs(endDate).diff(startDate);
  const diffDuration = dayjs.duration(dateDiff);
  
  const hours = diffDuration.hours();
  const minutes = diffDuration.minutes();
  const days = diffDuration.days();

  const daysString = days !== 0 ? `${days} d` : '';
  
  return `${daysString} ${hours} h ${minutes} min ago`;
}

export function weeksToDays(weeks: number) {
  return weeks * 7;
}

export function monthsToDays(months: number) {
  return months * 30;
}